import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Kurzes staleTime, damit ein Tab-Wechsel / Zurücknavigieren frische Daten
      // holt (sonst greift refetchOnWindowFocus wegen langer Freshness nicht).
      staleTime: 1000 * 30,
      retry: 1,
      // Zurückwechseln auf den Tab lädt aktuelle Daten (Workflow-Fortschritt,
      // Änderungen anderer Nutzer) — ohne manuelles Aktualisieren.
      refetchOnWindowFocus: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
